import {
    deleteAslDeviceDetails,
    fetchAslDeviceDetails, fetchAslStatusDetails,
    setAslDeviceDetails, updateAslConfiguration,
    updateAslDeviceDetails, updateAslDeviceMac,
    updateAslMonitoringDetails
} from "../network/AslDeviceOverviewNetworkAPI";
import {getTimestampNow} from "../../../util/Util";

export const AslDeviceOverviewReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "LOAD_VIEW":
            fetchAslDeviceDetails(action.data.dispatcher)
            return state
        case "LOAD_STATUS":
            fetchAslStatusDetails(action.data.dispatcher, state)
            return state
        case "ADD_DEVICE_DATA":
            setAslDeviceDetails(action.data.dispatcher, action.data.stateValues)
            return state
        case "UPDATE_DEVICE_DATA":
            updateAslDeviceDetails(action.data.dispatcher, action.data.stateValues)
            return state
        case "DELETE_DEVICE_DATA":
            deleteAslDeviceDetails(action.data.dispatcher, action.data.mac)
            return state
        case "UPDATE_DEVICE_MAC":
            updateAslDeviceMac(action.data.dispatcher, action.data.stateValues, action.data.mac)
            return state
        case "UPDATE_ASL_CONFIGURATION":
            updateAslConfiguration(action.data.dispatcher, action.data.configurations, action.data.mac)
            return state
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "UPDATE_MONITORING_DATA":
            updateAslMonitoringDetails(action.data.dispatcher, action.data.stateValues, action.data.mac)
            return state
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/reducer/AslDeviceOverviewReducer.js